import React from "react";
import FrequentlyAskedQuestions from "../Components/FrequentlyAskedQuestions";

function FAQPage() {
  return (
    <div className="bg-gray-50 min-h-screen">
      <FrequentlyAskedQuestions />
    </div>
  );
}

export default FAQPage;
